
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30894',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30894",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55461",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8429",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11884",
  "I18n": "static-7.1690",
  "quartz": "static-1.7561",
  "quartz-config": "static-1.1339",
  "quartz-core": "static-1.6780",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1013",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55448",
  "feedback-utils": "static-1.55452",
  "forms-embed-utils-lib": "static-1.4858",
  "forms-utils-lib": "static-1.13209",
  "foundations-assets": "static-1.5281",
  "foundations-components": "static-1.8623",
  "foundations-theming": "static-1.4871",
  "hub-http": "static-1.6603",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12191",
  "icons": "static-2.698",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4181",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17121",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5611",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.511",
  "tinymce-plugins": "static-1.58368",
  "transmute": "static-2.97",
  "ui-images": "static-2.1268",
  "UIComponents": "static-3.8830",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3838",
  "quartz-webpack": "static-1.3785",
  "foundations-theming-specialty": "static-1.2587",
  "property-description-translator": "static-1.4215",
  "HeadJS": "static-2.810",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3540",
  "msw": "static-1.39",
  "msw-config": "static-1.15",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4702",
  "jasmine-runner": "static-1.6840",
  "opentelemetry-fe-types": "static-1.177",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.895",
  "hubspotter-http": "static-1.4916",
  "mobile-manifest-mixins": "static-1.591",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.552",
  "quartz-auth": "static-1.1236",
  "quartz-head": "static-1.1226",
  "quartz-i18n": "static-1.1236",
  "quartz-routing": "static-1.991",
  "quartz-test": "static-1.1236",
  "quartz-tracking": "static-1.940",
  "trellis-components": "static-1.2897",
  "ui-fonts": "static-1.1146",
  "usage-tracker-container": "static-1.7694",
  "usage-tracker-core": "static-1.7554",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.281",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8574",
  "sanitize-text": "static-1.8550",
  "PatternValidationJS": "static-1.3281",
  "ReduxMessenger": "static-2.10763",
  "outpost": "static-1.4530",
  "rpc-client-utils": "static-1.5059",
  "sanitize": "static-1.4864",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4892",
  "floating-ui": "static-1.66",
  "hs-story-utils": "static-1.9817",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.87",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2878",
  "bend-plugin-foundations-theming": "static-1.3354",
  "foundations-theming-base": "static-1.3856",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.350",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9880",
  "atom": "static-1.5472",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8310",
  "ContentUtils": "static-1.69298",
  "data-token-picker": "static-1.17007",
  "file-manager-components": "static-1.24678",
  "FileManagerCore": "static-1.40177",
  "FileManagerLib": "static-1.40318",
  "frontend-preferences-client": "static-1.8313",
  "hub-http-contrib": "static-1.3418",
  "interframe": "static-3.5134",
  "layout-dnd-components": "static-1.13094",
  "layout-dnd-utils": "static-1.12069",
  "property-translator": "static-1.5774",
  "react-codemirror": "static-1.11034",
  "react-colorpicker": "static-2.10605",
  "reference-resolvers-lite": "static-1.8495",
  "rich-text-lib": "static-1.20433",
  "tinymce-data": "static-1.41339",
  "tinymce-themes": "static-1.57224",
  "ui-addon-emoji-picker": "static-1.10261",
  "ui-addon-sales-email": "static-1.5595",
  "ui-brand-identity-lib": "static-1.16745",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.94",
  "hub-http-shared-msw-handlers": "static-1.10759",
  "hubspotter-http-shared-msw-handlers": "static-1.10757",
  "usage-tracker-session-replay": "static-1.5390",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1369",
  "tanstack-virtual": "static-1.41",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.469",
  "chirp-fetch": "static-1.2293",
  "stylex-utils": "static-1.156",
  "chatspot-core": "static-1.23376",
  "copilot-toolkit": "static-1.11994",
  "customer-data-objects-ui-components": "static-1.13422",
  "data-fetching-client": "static-1.10039",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5152",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29459",
  "usage-tracker": "static-1.7704",
  "cms-field-types": "static-1.5204",
  "content-icons-ui": "static-1.2413",
  "integrations-lib": "static-1.17241",
  "customer-data-objects": "static-1.8084",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1955",
  "apollo-link-hub-http": "static-2.5014",
  "apollo-stack-hubspot": "static-3.97",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4536",
  "poll-commands": "static-1.3864",
  "ui-addon-iframeable": "static-1.9471",
  "video-components-external": "static-1.12296",
  "video-data-lib": "static-1.35954",
  "breeze-artifacts-sdk": "static-1.608",
  "audio-components": "static-1.6460",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29933",
  "FileManagerImages": "static-1.37829",
  "foundations-components-legacy": "static-1.1648",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.654",
  "ui-universal-auth": "static-1.9576",
  "urlinator": "static-1.4909",
  "video-components": "static-1.14298",
  "video-embed": "static-1.36788",
  "ts-schema": "static-1.4350",
  "ContentData": "static-1.69373",
  "layout-data-lib": "static-1.10394",
  "react-dnd-compat": "static-1.5006",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1938",
  "external-options-client-types": "static-1.4398",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7287",
  "hs-promise-utils": "static-1.5982",
  "inbound-db-properties-service-client": "static-1.4100",
  "NamespacedHubStyle": "static-2.9315",
  "growth-onboarding-confetti": "static-1.3456",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11541",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5830",
  "magpie-types": "static-1.5290",
  "simple-logging-lib": "static-1.3445",
  "avatar-components": "static-1.2875",
  "customer-data-ui-utilities": "static-1.10224",
  "growth-onboarding-feedback-components": "static-1.6978",
  "flux-actions": "static-1.377",
  "hubspot-apollo-client": "static-1.5267",
  "integrations-error-boundary-lib": "static-1.14656",
  "integrations-tracking-lib": "static-1.6003",
  "laboratory-lib": "static-3.7543",
  "native-integrations-shared-strings": "static-1.8156",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10664",
  "unified-auth": "static-1.1090",
  "breeze-engine-chat-components": "static-1.933",
  "breeze-engine-core": "static-1.1233",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1028",
  "navigation-messaging": "static-1.8319",
  "content-media-composition-data-lib": "static-1.13425",
  "content-media-compositions": "static-2.17432",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19525",
  "nudge-client-utils": "static-1.3274",
  "unified-auth-core-lib": "static-1.1372",
  "social-insights-client-types": "static-1.22784",
  "advanced-menus-core": "static-1.15689",
  "advanced-menus-lib": "static-1.12509",
  "ExportDialog": "static-6.10770",
  "ui-memberships-settings-lib": "static-1.34992",
  "conditional-properties-service-client": "static-1.4072",
  "crm-pipelines-api-client-types": "static-1.4403",
  "fdsr-migration-layer": "static-1.406",
  "framework-builder-read-service-client": "static-1.4278",
  "framework-data-schema-quick-fetch": "static-1.7192",
  "inbound-db-meta-service-client": "static-1.3730",
  "multi-currency-client-types": "static-1.3967",
  "persist-promise": "static-1.4095",
  "foundations-components-test-utils": "static-1.6106",
  "reactive-lib": "static-1.1113",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.726",
  "universal-page-editor-lib": "static-1.3403",
  "adobe-sign-auth-lib": "static-1.621",
  "ads-unified-auth-lib": "static-1.1669",
  "custom-vendor-connection-lib": "static-1.140",
  "google-sheets-integration-lib": "static-1.1183",
  "microsoft-drive-auth-lib": "static-1.337",
  "surveymonkey-integration-lib": "static-1.687",
  "slack-ui-library": "static-1.10790",
  "bend-plugin-pulse": "static-1.531",
  "event-emitter": "static-1.1351",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3031",
  "nudge-renderer-utils": "static-1.3350",
  "onboarding-tours": "static-1.17264",
  "whisper-core-api": "static-1.7485",
  "fsm": "static-1.4146",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15688",
  "simple-menus-lib": "static-1.17205",
  "settings-ui-lib": "static-1.12918",
  "crm-record-cards-service-types": "static-1.3826",
  "location-customization-utils-lib": "static-1.10263",
  "getting-started-shared-tasks": "static-1.19405",
  "growth-data-modal": "static-1.6012",
  "growth-onboarding-next-action-utils": "static-1.2840",
  "navigation-components": "static-1.18992",
  "onboarding-tours-client": "static-1.5479",
  "onboarding-tours-utils": "static-1.1331",
  "ui-shepherd-tracker": "static-1.8045",
  "user-context": "static-1.5473",
  "react-flip-move": "static-1.81",
  "onboarding-data-sync-lib": "static-1.2694",
  "growth-onboarding-next-action-components": "static-1.2868",
  "user-context-client": "static-1.4902",
  "nest": "static-1.628",
  "getting-started-shared-tasks-store": "static-1.18523",
  "InboxConnectUtils": "static-4.15703",
  "meetings-connect-utils-lib": "static-1.8007",
  "onboarding-scopes": "static-1.6845"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30894",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55461",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8429",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11884",
  "I18n": "/I18n/static-7.1690",
  "quartz": "/quartz/static-1.7561",
  "quartz-config": "/quartz-config/static-1.1339",
  "quartz-core": "/quartz-core/static-1.6780",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1013",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55448",
  "feedback-utils": "/feedback-utils/static-1.55452",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4858",
  "forms-utils-lib": "/forms-utils-lib/static-1.13209",
  "foundations-assets": "/foundations-assets/static-1.5281",
  "foundations-components": "/foundations-components/static-1.8623",
  "foundations-theming": "/foundations-theming/static-1.4871",
  "hub-http": "/hub-http/static-1.6603",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12191",
  "icons": "/icons/static-2.698",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4181",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17121",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5611",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "tinymce-plugins": "/tinymce-plugins/static-1.58368",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1268",
  "UIComponents": "/UIComponents/static-3.8830",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3838",
  "quartz-webpack": "/quartz-webpack/static-1.3785",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2587",
  "property-description-translator": "/property-description-translator/static-1.4215",
  "HeadJS": "/HeadJS/static-2.810",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3540",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.15",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4702",
  "jasmine-runner": "/jasmine-runner/static-1.6840",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.177",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hubspotter-http": "/hubspotter-http/static-1.4916",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.591",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.552",
  "quartz-auth": "/quartz-auth/static-1.1236",
  "quartz-head": "/quartz-head/static-1.1226",
  "quartz-i18n": "/quartz-i18n/static-1.1236",
  "quartz-routing": "/quartz-routing/static-1.991",
  "quartz-test": "/quartz-test/static-1.1236",
  "quartz-tracking": "/quartz-tracking/static-1.940",
  "trellis-components": "/trellis-components/static-1.2897",
  "ui-fonts": "/ui-fonts/static-1.1146",
  "usage-tracker-container": "/usage-tracker-container/static-1.7694",
  "usage-tracker-core": "/usage-tracker-core/static-1.7554",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.281",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8574",
  "sanitize-text": "/sanitize-text/static-1.8550",
  "PatternValidationJS": "/PatternValidationJS/static-1.3281",
  "ReduxMessenger": "/ReduxMessenger/static-2.10763",
  "outpost": "/outpost/static-1.4530",
  "rpc-client-utils": "/rpc-client-utils/static-1.5059",
  "sanitize": "/sanitize/static-1.4864",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4892",
  "floating-ui": "/floating-ui/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9817",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.87",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2878",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3354",
  "foundations-theming-base": "/foundations-theming-base/static-1.3856",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.350",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9880",
  "atom": "/atom/static-1.5472",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8310",
  "ContentUtils": "/ContentUtils/static-1.69298",
  "data-token-picker": "/data-token-picker/static-1.17007",
  "file-manager-components": "/file-manager-components/static-1.24678",
  "FileManagerCore": "/FileManagerCore/static-1.40177",
  "FileManagerLib": "/FileManagerLib/static-1.40318",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8313",
  "hub-http-contrib": "/hub-http-contrib/static-1.3418",
  "interframe": "/interframe/static-3.5134",
  "layout-dnd-components": "/layout-dnd-components/static-1.13094",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12069",
  "property-translator": "/property-translator/static-1.5774",
  "react-codemirror": "/react-codemirror/static-1.11034",
  "react-colorpicker": "/react-colorpicker/static-2.10605",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8495",
  "rich-text-lib": "/rich-text-lib/static-1.20433",
  "tinymce-data": "/tinymce-data/static-1.41339",
  "tinymce-themes": "/tinymce-themes/static-1.57224",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10261",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5595",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16745",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.94",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10759",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10757",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5390",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1369",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.469",
  "chirp-fetch": "/chirp-fetch/static-1.2293",
  "stylex-utils": "/stylex-utils/static-1.156",
  "chatspot-core": "/chatspot-core/static-1.23376",
  "copilot-toolkit": "/copilot-toolkit/static-1.11994",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13422",
  "data-fetching-client": "/data-fetching-client/static-1.10039",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5152",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29459",
  "usage-tracker": "/usage-tracker/static-1.7704",
  "cms-field-types": "/cms-field-types/static-1.5204",
  "content-icons-ui": "/content-icons-ui/static-1.2413",
  "integrations-lib": "/integrations-lib/static-1.17241",
  "customer-data-objects": "/customer-data-objects/static-1.8084",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1955",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5014",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4536",
  "poll-commands": "/poll-commands/static-1.3864",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9471",
  "video-components-external": "/video-components-external/static-1.12296",
  "video-data-lib": "/video-data-lib/static-1.35954",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.608",
  "audio-components": "/audio-components/static-1.6460",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29933",
  "FileManagerImages": "/FileManagerImages/static-1.37829",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1648",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.654",
  "ui-universal-auth": "/ui-universal-auth/static-1.9576",
  "urlinator": "/urlinator/static-1.4909",
  "video-components": "/video-components/static-1.14298",
  "video-embed": "/video-embed/static-1.36788",
  "ts-schema": "/ts-schema/static-1.4350",
  "ContentData": "/ContentData/static-1.69373",
  "layout-data-lib": "/layout-data-lib/static-1.10394",
  "react-dnd-compat": "/react-dnd-compat/static-1.5006",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1938",
  "external-options-client-types": "/external-options-client-types/static-1.4398",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7287",
  "hs-promise-utils": "/hs-promise-utils/static-1.5982",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4100",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9315",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3456",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11541",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5830",
  "magpie-types": "/magpie-types/static-1.5290",
  "simple-logging-lib": "/simple-logging-lib/static-1.3445",
  "avatar-components": "/avatar-components/static-1.2875",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10224",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6978",
  "flux-actions": "/flux-actions/static-1.377",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5267",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14656",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6003",
  "laboratory-lib": "/laboratory-lib/static-3.7543",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8156",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10664",
  "unified-auth": "/unified-auth/static-1.1090",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.933",
  "breeze-engine-core": "/breeze-engine-core/static-1.1233",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1028",
  "navigation-messaging": "/navigation-messaging/static-1.8319",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13425",
  "content-media-compositions": "/content-media-compositions/static-2.17432",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19525",
  "nudge-client-utils": "/nudge-client-utils/static-1.3274",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1372",
  "social-insights-client-types": "/social-insights-client-types/static-1.22784",
  "advanced-menus-core": "/advanced-menus-core/static-1.15689",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12509",
  "ExportDialog": "/ExportDialog/static-6.10770",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34992",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4072",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4403",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.406",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4278",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7192",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3730",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3967",
  "persist-promise": "/persist-promise/static-1.4095",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6106",
  "reactive-lib": "/reactive-lib/static-1.1113",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.726",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3403",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.621",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1669",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.140",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1183",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.337",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.687",
  "slack-ui-library": "/slack-ui-library/static-1.10790",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.531",
  "event-emitter": "/event-emitter/static-1.1351",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3031",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3350",
  "onboarding-tours": "/onboarding-tours/static-1.17264",
  "whisper-core-api": "/whisper-core-api/static-1.7485",
  "fsm": "/fsm/static-1.4146",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15688",
  "simple-menus-lib": "/simple-menus-lib/static-1.17205",
  "settings-ui-lib": "/settings-ui-lib/static-1.12918",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3826",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10263",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19405",
  "growth-data-modal": "/growth-data-modal/static-1.6012",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2840",
  "navigation-components": "/navigation-components/static-1.18992",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5479",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1331",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8045",
  "user-context": "/user-context/static-1.5473",
  "react-flip-move": "/react-flip-move/static-1.81",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2694",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2868",
  "user-context-client": "/user-context-client/static-1.4902",
  "nest": "/nest/static-1.628",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18523",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15703",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8007",
  "onboarding-scopes": "/onboarding-scopes/static-1.6845"
}
};
